

const initialState = {
  OptionFlags: { }
}

const agentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE':
      return action.data
    default:
      return state
  }
}

module.exports = agentReducer



// WEBPACK FOOTER //
// ./shared/stores/reducers/agents.js